/*
 * Palo Alto Theme
 *
 * Use this file to add custom Javascript to Palo Alto.  Keeping your custom
 * Javascript in this fill will make it easier to update Palo Alto. In order
 * to use this file you will need to open layout/theme.liquid and uncomment
 * the custom.js script import line near the bottom of the file.
 */

(function () {
  // Add custom code below this line

  /**
   * Cart recommendations carousel ("Recommended for you")
   *
   * Fills snippets/cart-recommended-products.liquid with products and (re)starts the carousel.
   *
   * Complementary products cannot be read from Liquid — the reserved
   * shopify--discovery--product_recommendation namespace is only reachable through the Product
   * Recommendations API. So we fetch sections/cart-recommendations here:
   *   1. intent=complementary — curated add-ons, needs setup in the Search & Discovery app
   *   2. intent=related       — auto-generated by Shopify, so this always returns something
   * A server-rendered fallback collection, when configured, is left alone unless the API has
   * something better to show.
   */
  var BLOCK = '[data-cart-recs]';
  var CONTENT = '[data-cart-recs-content]';
  var SLIDER = '[data-pair-products]';
  var CELL = '[data-upsell-holder]';

  // De slider loopt van rand tot rand; de kaarten springen in via de
  // snap-offset. Zo blijft de vorige kaart links zichtbaar in plaats van te
  // worden afgekapt door een padding. De afstand komt uit --cart-peek, zodat
  // mobiel (16px) en desktop (24px) in de CSS geregeld blijven.
  var PEEK_FALLBACK = 24;

  function peekFor(slider) {
    var value = parseInt(
      getComputedStyle(slider).getPropertyValue('--cart-peek'),
      10,
    );
    return isNaN(value) ? PEEK_FALLBACK : value;
  }

  /**
   * cellAlign blijft 'left', zodat een kaart op zijn linkerrand uitlijnt.
   * Alleen de cursor schuift op: Flickity zet die in getSize() op 0, hier op
   * PEEK px. Elke resize rekent hem opnieuw uit, vandaar ook het resize-event.
   */
  function setPeekOffset(flkty) {
    if (!flkty || !flkty.size || !flkty.size.innerWidth) return;

    flkty.cursorPosition = peekFor(flkty.element);
    flkty.positionSliderAtSelected();
  }

  /**
   * De slider wordt opgebouwd terwijl de lade nog verborgen is en meet dan
   * breedte 0, waardoor de offset niet gezet kan worden. Bij de eerste keer dat
   * hij echt breedte krijgt opnieuw meten. Alleen op een gewijzigde breedte,
   * zodat de hoogteaanpassing van de slider geen lus veroorzaakt.
   */
  function watchWidth(slider, flkty) {
    if (typeof ResizeObserver === 'undefined') return;

    var lastWidth = slider.clientWidth;
    new ResizeObserver(function () {
      if (slider.clientWidth === lastWidth) return;
      lastWidth = slider.clientWidth;
      flkty.resize();
    }).observe(slider);
  }

  /**
   * Koppelt de vorige/volgende-knoppen in de kop aan de carousel. Flickity's
   * eigen knoppen worden niet gebruikt: zo staat het chevron-icoon van het
   * theme in de kop, op de plek van de vroegere paginabolletjes.
   */
  function bindNav(block, flkty) {
    var nav = block.querySelector('[data-cart-recs-nav]');
    if (!nav || nav.dataset.navBound) return;
    nav.dataset.navBound = 'true';
    nav.hidden = false;

    nav.querySelector('[data-cart-recs-prev]').addEventListener('click', function () {
      flkty.previous();
    });

    nav.querySelector('[data-cart-recs-next]').addEventListener('click', function () {
      flkty.next();
    });
  }

  /**
   * Bewaakt de snap-offset en de navigatie. Flickity zet cursorPosition bij elke
   * hermeting terug op 0 en wordt opgebouwd terwijl de lade nog verborgen is,
   * dus dit loopt mee met elke scan: idempotent en zelfherstellend.
   */
  function ensureSliders() {
    var Flickity =
      (window.themeVendor && window.themeVendor.Flickity) || window.Flickity;
    if (!Flickity) return;

    document.querySelectorAll(SLIDER).forEach(function (slider) {
      var flkty = Flickity.data(slider);
      if (!flkty || !flkty.size || !flkty.size.innerWidth) return;

      var peek = peekFor(slider);
      if (flkty.cursorPosition !== peek) {
        flkty.cursorPosition = peek;
        flkty.positionSliderAtSelected();
      }

      var block = slider.closest(BLOCK);
      if (block) bindNav(block, flkty);
    });
  }

  function startSlider(block) {
    // Flickity is bundled in vendor.js as themeVendor.Flickity, not on window
    var Flickity = (window.themeVendor && window.themeVendor.Flickity) || window.Flickity;
    if (!Flickity) return;

    var slider = block.querySelector(SLIDER);
    if (!slider) return;

    if (slider.classList.contains('flickity-enabled')) {
      var existing = Flickity.data(slider);
      if (existing) {
        existing.reloadCells();
        existing.resize();
        setPeekOffset(existing);
      }
      return;
    }

    if (slider.querySelectorAll(CELL).length < 2) return;

    // Options mirror CartDrawer.renderPairProducts() in theme.dev.js so both paths look identical
    var flkty = new Flickity(slider, {
      wrapAround: true,
      // Navigatie zit in de kop (bindNav), niet als bolletjes of eigen knoppen
      pageDots: false,
      adaptiveHeight: true,
      prevNextButtons: false,
      // Kaarten links uitlijnen zodat de eerste op 24px staat en de volgende
      // er half naast piept, zoals in Figma 1754-10985
      cellAlign: 'left',
      // Eén kaart per stap. Zonder dit bundelt Flickity alle kaarten die samen
      // in beeld passen tot één slide, waardoor een brede lade in één keer
      // voorbij de hele groep springt en de vorige kaart volledig verdwijnt.
      groupCells: 1,
      on: {
        ready: function () {
          this.reloadCells();
          requestAnimationFrame(this.resize.bind(this));
        },
      },
    });

    // Buiten de ready-handler om: die wordt niet altijd afgemaakt
    requestAnimationFrame(function () {
      setPeekOffset(flkty);
    });

    // getSize() rekent cursorPosition bij elke resize opnieuw uit de opgeslagen
    // fractie; die klopt alleen voor de oude breedte, dus opnieuw zetten
    flkty.on('resize', function () {
      setPeekOffset(flkty);
    });

    watchWidth(slider, flkty);
  }

  function fetchIntent(baseUrl, intent) {
    return fetch(baseUrl + '&intent=' + intent)
      .then(function (response) {
        return response.ok ? response.text() : '';
      })
      .then(function (text) {
        if (!text) return '';
        var parsed = document.createElement('div');
        parsed.innerHTML = text;
        var content = parsed.querySelector(CONTENT);
        return content && content.innerHTML.trim().length ? content.innerHTML : '';
      })
      .catch(function () {
        return '';
      });
  }

  // The holder is server-rendered with `hidden` and normally only unhidden by
  // CartDrawer.toggleClassesOnContainers() after a cart mutation. On the first
  // open of an already-filled cart that never runs, so reveal it here as soon
  // as there are cards to show.
  function reveal(block) {
    var holder = block.closest('[data-pair-products-holder]');
    if (holder && block.querySelectorAll(CELL).length > 0) {
      holder.classList.remove('hidden');
    }

    // Prefer the theme's own CartDrawer re-init: renderPairProducts() starts the
    // same Flickity carousel ánd bindt de quick-view popup op de plusknoppen van
    // producten met meerdere varianten. startSlider is de fallback voor de cart
    // page, waar window.cart niet bestaat.
    if (window.cart && typeof window.cart.renderPairProducts === 'function') {
      window.cart.renderPairProducts();
    } else {
      startSlider(block);
    }

    requestAnimationFrame(ensureSliders);
  }

  function load(block) {
    if (block.dataset.cartRecsLoaded) return;
    block.dataset.cartRecsLoaded = 'true';

    var baseUrl = block.dataset.recommendationsUrl;

    if (!baseUrl) {
      reveal(block);
      return;
    }

    // Show the server-rendered fallback right away rather than waiting on the network
    if (block.hasAttribute('data-has-fallback')) reveal(block);

    fetchIntent(baseUrl, 'complementary')
      .then(function (markup) {
        return markup || fetchIntent(baseUrl, 'related');
      })
      .then(function (markup) {
        if (markup) block.innerHTML = markup;
        reveal(block);
      });
  }

  /**
   * De positie-indicator van de productgalerij is een overlay op de dots-rij
   * (zie .flickity-page-dots::after in custom.css). Die schuift op --dot-index,
   * dus met een transform: de enige eigenschap die iOS Safari volledig op de
   * compositor afhandelt en die dus niet hapert tijdens een swipe.
   */
  function bindGalleryDots() {
    var Flickity =
      (window.themeVendor && window.themeVendor.Flickity) || window.Flickity;
    if (!Flickity) return;

    document
      .querySelectorAll('.product-single__media-slider')
      .forEach(function (gallery) {
        var flkty = Flickity.data(gallery);
        if (!flkty) return;

        var sync = function () {
          var dots = gallery.querySelector('.flickity-page-dots');
          if (dots) dots.style.setProperty('--dot-index', flkty.selectedIndex);
        };

        // De vlag staat op de instantie: het theme kan de slider opnieuw
        // opbouwen, en dan hoort er opnieuw gebonden te worden.
        if (!flkty._dotIndexBound) {
          flkty._dotIndexBound = true;
          flkty.on('select', sync);
        }

        sync();
      });
  }

  function scan() {
    document.querySelectorAll(BLOCK).forEach(load);
    ensureSliders();
    bindGalleryDots();
  }

  // Coalesce bursts of mutations into one scan per tick. setTimeout instead of
  // requestAnimationFrame: rAF never fires in a hidden/background tab, which
  // would leave scanQueued permanently true and block every later scan.
  var scanQueued = false;
  function queueScan() {
    if (scanQueued) return;
    scanQueued = true;
    setTimeout(function () {
      scanQueued = false;
      scan();
    }, 0);
  }

  // The cart drawer is rendered from a <template> on first open and replaced on every cart
  // update, so watch for the block appearing rather than binding once on load.
  new MutationObserver(queueScan).observe(document.documentElement, {
    childList: true,
    subtree: true,
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan);
  } else {
    scan();
  }

  /**
   * Cart line item edit toggle
   *
   * Het potlood opent de wijzig-stand van een cart-regel (variant-selects +
   * vinkje), het vinkje sluit hem weer. De selects zelf wisselen de variant
   * direct bij een keuze (cartVariantChangeEvent in theme.dev.js); na zo'n
   * update rendert de drawer opnieuw in de dichte stand. Gedelegeerd op
   * document omdat de drawer bij elke cart-update opnieuw wordt opgebouwd.
   */
  document.addEventListener('click', function (event) {
    var toggle = event.target.closest('[data-item-edit-toggle]');
    if (!toggle) return;

    event.preventDefault();

    var item = toggle.closest('[data-cart-item]');
    if (item) item.classList.toggle('is-editing');
  });

  /**
   * Afrekenen terwijl een variantwijziging nog wordt opgeslagen
   *
   * De mousedown hierboven start het opslaan; de klik erna zou het formulier
   * versturen met de cart van vóór die wijziging. In plaats van de knop te
   * blokkeren onthouden we de bedoeling: de klik wordt tegengehouden en zodra
   * de cart is bijgewerkt gaat hij alsnog door naar de checkout.
   */
  var CHECKOUT = '[name="checkout"]';

  function cartIsBusy() {
    return Boolean(
      document.querySelector('[data-cart-item][data-variant-pending]') ||
        document.querySelector('[data-cart-item].is-loading'),
    );
  }

  var checkoutQueued = false;

  function checkoutWhenSaved() {
    if (checkoutQueued) return;
    checkoutQueued = true;

    var tries = 0;

    (function attempt() {
      // De lade wordt opnieuw opgebouwd, dus de knop van zojuist bestaat niet
      // meer; wachten tot de nieuwe er is én weer klikbaar is
      var button = document.querySelector(CHECKOUT);

      if (!cartIsBusy() && button && !button.hasAttribute('disabled')) {
        checkoutQueued = false;
        button.click();
        return;
      }

      if (++tries > 100) {
        checkoutQueued = false;
        return;
      }

      setTimeout(attempt, 100);
    })();
  }

  // CartDrawer schakelt tijdens het opslaan alle knoppen uit, en een
  // uitgeschakelde knop vuurt geen click. De bedoeling leggen we daarom al op
  // mousedown vast; anders zou die eerste klik verloren gaan. Op iOS begint
  // dat nog eerder: touchstart commit de wijziging en schakelt de knop uit
  // voordat er überhaupt een mouse-event komt, dus daar luisteren we ook.
  var captureCheckoutIntent = function (event) {
    if (!event.target.closest(CHECKOUT)) return;
    if (!cartIsBusy()) return;

    // De handlers die de wijziging opslaan draaien op ditzelfde event:
    // pas daarna staat vast of er echt iets wordt bijgewerkt
    setTimeout(function () {
      if (cartIsBusy()) checkoutWhenSaved();
    }, 0);
  };

  document.addEventListener('mousedown', captureCheckoutIntent);
  document.addEventListener('touchstart', captureCheckoutIntent, {
    passive: true,
  });

  // Toetsenbord (Enter) stuurt alleen een click; zolang de knop nog aan staat
  // vangen we die hier op
  document.addEventListener('click', function (event) {
    var button = event.target.closest(CHECKOUT);
    if (!button || !cartIsBusy()) return;

    event.preventDefault();

    document
      .querySelectorAll('[data-cart-item][data-variant-pending]')
      .forEach(function (item) {
        if (window.cart && typeof window.cart.commitVariantChange === 'function') {
          window.cart.commitVariantChange(item);
        }
      });

    checkoutWhenSaved();
  });

  // Buiten de velden klikken sluit de wijzig-stand. Is er wel iets gekozen, dan
  // slaat CartDrawer dat op dezelfde mousedown op en rendert de regel opnieuw.
  document.addEventListener('mousedown', function (event) {
    var open = document.querySelectorAll('[data-cart-item].is-editing');
    if (!open.length) return;

    Array.prototype.forEach.call(open, function (item) {
      var editArea = item.querySelector('[data-item-edit-area]');
      if (editArea && editArea.contains(event.target)) return;
      item.classList.remove('is-editing');
    });
  });

  /**
   * Aantal-kaarten: de buitenring (badge-strip "MEEST GEKOZEN", rand en
   * waszak-rij) valt buiten het label en deed niets bij een klik. Het label
   * zelf is position: relative, dus een CSS-overlay kan het klikvlak niet
   * oprekken; daarom selecteert deze delegate de optie bij elke klik binnen
   * de kaart. Kliks op het label/de input doen het al zelf.
   */
  document.addEventListener('click', function (event) {
    var button = event.target.closest('.radio__buttons--aantal .radio__button');
    if (!button) return;
    if (event.target.closest('label, input, a, button, select')) return;

    var input = button.querySelector('.radio__input');
    if (input && !input.checked) input.click();
  });

  // Preorder widget
  document.addEventListener('theme:variant:change', function (event) {
    const container = event.target;
    const variant = event.detail.variant;
    if (!variant) return;

    const dataScript = container.querySelector('[id^="PreorderData-"]');
    if (!dataScript) return;

    const data = JSON.parse(dataScript.textContent);
    const info = data[variant.id];
    const widget = container.querySelector('[data-preorder-widget]');
    const badge = container.querySelector('[data-preorder-badge]');
    const shipping = container.querySelector('[data-preorder-shipping]');
    const buyButtonText = container.querySelector('[data-add-to-cart-text]');

    if (info && info.preorder) {
      widget?.classList.remove('hidden');

      if (info.extra) {
        badge.textContent = `${info.extra}% pre-order korting`;
        badge.classList.remove('hidden');
      } else {
        badge.classList.add('hidden');
      }

      if (shipping) {
        shipping.textContent = `Verzending: ${info.datum}`;
      }

      if (buyButtonText) {
        buyButtonText.textContent = theme.strings.preorder;
      }
    } else {
      widget?.classList.add('hidden');
    }
  });

  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
